import { Organization } from "@App/types";

type OrganizationSettings = NonNullable<Organization["settings"]>;

export type GarageListSettings = OrganizationSettings["garage_list"];

/**
 * getGarageListSettings reads the garage list settings the backend serialises into
 * `window.organization` from `config/organizations/{slug}.php`.
 *
 * Reading them off the window is only necessary where the organization isn't available
 * from the redux store yet — most notably while the reducers build their initial state.
 * Everywhere else, prefer `state.orders.organization`.
 */
export const getGarageListSettings = (): Partial<GarageListSettings> =>
  window.organization?.settings?.garage_list ?? {};
